module.exports = __webpack_public_path__ + "static/media/Flame.b8884d2c.svg";